import React from 'react';

import moment from 'moment';
import { bool, func, instanceOf, oneOf } from 'prop-types';

import { DatePickerMode } from '@philips-emr/tws-components-api';
import { enumValues, trigger } from '@philips-emr/tws-utils';

function getTitle(mode, date) {
  const year = moment(date).format('YYYY');
  const month = moment(date).format('MMMM');
  const yearMinus11 = moment(date).utc().add(-11, 'year').format('YYYY');

  if (mode === DatePickerMode.DECADES) {
    return `${yearMinus11}-${year}`;
  }

  if (mode === DatePickerMode.YEARLY) {
    return year;
  }

  return `${month} ${year}`;
}

function DatePickerTimeSpan({ date, mode, enableNext, enablePrev, onArrowClick, onTitleClick }) {
  const onNextClick = trigger(onArrowClick, 1);
  const onPrevClick = trigger(onArrowClick, -1);
  const title = getTitle(mode, date);

  return (
    <div className="c-date-picker__header">
      {enablePrev &&
      <div className="c-date-picker__button c-date-picker__button--left" onClick={onPrevClick} />}

      <div className="c-date-picker__title" onClick={onTitleClick}>
        {title}
      </div>

      {enableNext &&
      <div className="c-date-picker__button c-date-picker__button--right" onClick={onNextClick} />}
    </div>
  );
}

DatePickerTimeSpan.propTypes = {
  mode: oneOf(enumValues(DatePickerMode)),
  date: instanceOf(moment),
  onArrowClick: func,
  onTitleClick: func,
  enableNext: bool,
  enablePrev: bool,
};

DatePickerTimeSpan.defaultProps = {
  enableNext: true,
  enablePrev: true,
};

export default DatePickerTimeSpan;
